import { render, staticRenderFns } from "./UrlWrapper.vue?vue&type=template&id=756ca453&"
import script from "./UrlWrapper.vue?vue&type=script&lang=js&"
export * from "./UrlWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports